import { isIterable } from "@thi.ng/checks";
import { iterator1 } from "../iterator";
export function toggle(on, off, initial = false, src) {
    return isIterable(src)
        ? iterator1(toggle(on, off, initial), src)
        : ([init, complete, reduce]) => {
            let state = initial;
            return [
                init,
                complete,
                (acc) => reduce(acc, (state = !state) ? on : off),
            ];
        };
}
